export const messageids = {
  messageid: {
    TKMSG_SCR0001E:
      "連絡先メールアドレスの入力内容が、確認用メールアドレスと一致してません。入力内容をご確認ください。",
    TKMSG_SCR0002E:
      "給与支払遅延がある場合は申出の拒絶理由に該当するため、お申し込みができません。機構へお問い合わせ下さい。",
    TKMSG_SCR0003E:
      "当該申込施設が1年以内に部分解除したことが「有」の場合、法令に基づき「申出の拒絶理由」に該当し、申出を承諾できないため、お申し込みができません。機構へお問い合わせ下さい。",
    TKMSG_SCR0004E: "ファイルデータがありません。",
    TKMSG_SCR0005E:
      "変換可能なファイル拡張子ではありません。添付可能なファイル拡張子は、pdf・jpg・jpeg・png・bmp・docx・xlsx・xdw・heic・webp・jfif・heifとなります。",
    TKMSG_SCR0006E:
      "変換可能なファイル最大サイズを超えています。ファイルサイズの上限は10MBとなります。",
    TKMSG_SCR0007E: "パラメータエラー",
    TKMSG_SCR0008E: "システムエラー",
    TKMSG_SCR0009E: "郵便番号が未入力です。",
    TKMSG_SVR0001E: "入力頂いた施設情報は既に登録済みとなります。",
    TKMSG_SVR0001W:
      "登録済みの施設情報の中に、施設種類・施設名称・郵便番号が同じ施設情報が存在します。ご登録予定の施設情報が既に登録済みのものでないかご確認ください。問題無い場合は再度、「登録」ボタンまたは「続けて登録」ボタンを押下してください。",
    TKMSG_SVR0002W:
      "契約希望が変更されていますが、変更する場合は事前に機構への相談が必要となります。",
    TKMSG_SCR0001W:
      "施設区分が社会福祉施設等から特定介護保険施設等又は申出施設等になる場合、当該施設・事業については、一人当たりの掛金が単位掛金額×３となります。",
    TKMSG_SCR0010E:
      "加入日が当該共済契約者の契約日の翌日以降でなければ加入できません。契約日の翌日以降の日付を入力してください。",
    TKMSG_SCR0011E:
      "加入日が当該施設の新設・申出日の翌日以降でなければ加入できません。新設・申出日の翌日以降の日付を入力してください。",
    TKMSG_SCR0012E:
      "俸給の額が73,999円以下となっています。加入要件を満たすかご確認ください。加入要件を満たす場合は、機構へお問い合わせ下さい。",
    TKMSG_SCR0013E:
      "１４歳以下の職員は加入できません、生年月日の入力に誤りがないか確認してください。",
    TKMSG_SCR0018W:
      "入力された「生年月日」の場合、登録職員が８０歳以上になります、生年月日の入力に誤りがないか確認してください。",
    TKMSG_SCR0015E: "加入日よりも前の月は、「ならない月」の登録はできません。",
    TKMSG_SCR0016E:
      "加入日よりも前の日付を、「退職（予定）日」に登録できません。",
    TKMSG_SCR0017E:
      "出生日は、退職（予定）日よりも前の日付で入力してください。また、修正後に産前休暇を「ならない月」として登録しないようにご注意ください。",
    TKMSG_SCR0018E:
      "育児休業終了（予定）日は、退職（予定）日よりも後の日付で入力できません。退職（予定）日に合わせた日付としてください。",
    TKMSG_SCR0019E:
      "出生日は、本日までの日付で入力してください。（未来日の入力はできません）",
    TKMSG_SCR0020E: "育児休業開始日は、加入日以降の日付で入力してください。",
    TKMSG_SCR0021E:
      "出生日よりも前の日付で育児休業開始日を入力できません。出生日か育児休業開始日を修正してください。",
    TKMSG_SCR0022E:
      "パパ・ママ育休プラスが「無」かつ半年延長の理由が未選択のため、育児休業終了（予定）日は出生日の1年後までしか登録できません。入力内容をご確認ください。",
    TKMSG_SCR0023E:
      "「育児休業終了日」は、出生日の１年半後を超える日付を入力できません。",
    TKMSG_SCR0024E:
      "「育児休業終了日」は、出生日の２年後を超える日付を入力できません。",
    TKMSG_SCR0025E:
      "パパママ育休プラスが「有」の場合に、「児休業終了（予定）日」は出生日の1年2か月後を超える日付を入力できません。",
    TKMSG_SCR0026E: "同一出生日、育児休業開始日で育児休業が登録済です。",
    TKMSG_SCR0027E:
      "「産後パパ育休」は、同一の子について３回以上登録できません。",
    TKMSG_SCR0012W:
      "産後パパ育休は、育児休業終了日を子の出生日から８週間（５６日）を超えた日で登録することはできません。",
    TKMSG_SCR0029E:
      "「産後パパ育休」は、同一の子について４週間（２８日）を超えて登録できません。",
    TKMSG_SCR0002W:
      "育児休業開始日が出産日の「8週間後+１日」(57日)よりも前の日付で入力されています。間違いないか確認してください。",
    TKMSG_SCR0030E: "引継ぎコードを入力してください。",
    TKMSG_SCR0031E:
      "災害救助法適用による申請である場合には、「延長申請の理由証明書」を添付する必要となります。",
    TKMSG_SCR0032E: "退職年月日よりも後の日付で出生日を入力できません。",
    TKMSG_SCR0010W:
      "現在、ご選択中の退職理由は、労働災害又は通勤災害による傷病や死亡による退職を理由とするものであり、証明する書類が必要となります。傷病による場合は、障害の程度が厚生年金保険法第４７条第２項に規定する障害等級（リンク）に該当することが必要です。また、死亡による場合は、労災保険の適用を受けていることが必要です。労働災害又は通勤災害と関連がない場合は普通退職となりますので、関連がない場合は普通退職を選択してください。",
    TKMSG_SCR0033E:
      "退職（予定）日を、前々年度の日付に変更はできません。日付に誤りがない場合は、以下のサイトからお問い合わせください。退職再加入の対応フォーム（https://www.wam.go.jp/hp/info-tabid-640/info-kyousai01-tabid-2093/）",
    TKMSG_SCR0034E:
      "育児休業期間と被る月は、「ならない月」の登録ができません。チェックをはずしてください。",
    TKMSG_SCR0003W:
      "退職月の退職日が12日～15日となっています。11日以上出勤しているか、再度確認してください。10日以下の場合は「ならない月」の登録が必要です。",
    TKMSG_SCR0004W:
      "給与規程で本俸が定められていない職員（パート労働者等）については、実支給額を入力するのではなく雇用契約書で定める労働条件をもとに計算した金額を入力してください。",
    TKMSG_SCR0005W:
      "退職金請求の順番を「福祉医療機構を先に請求」から「福祉医療機構を後に請求」に変更する場合、事前に社会福祉協議会等へ連絡してください。",
    TKMSG_SCR0006W:
      "退職金請求の順番を「福祉医療機構を後に請求」から「福祉医療機構を先に請求」に変更する場合、共済契約者等において、納税に係るとりまとめ処理が必要となります。",
    TKMSG_SCR0035E:
      "入力された退職所得に係る情報は、機構と重複した勤務期間がないため入力や添付は不要です。就労年月日、退職年月日に誤りがない場合には、「源泉徴収票の登録枚数」を不要にして次へ進んでください。",
    TKMSG_SCR0011W:
      "支払金額３千万円以上となるため、入力内容をご確認ください。",
    TKMSG_SCR0036E:
      "退職（予定）日を、前年度の日付に変更はできません。日付に誤りがない場合は、以下のサイトからお問い合わせください。退職再加入の対応フォーム（https://www.wam.go.jp/hp/info-tabid-640/info-kyousai01-tabid-2093/）",
    TKMSG_SCR0037E:
      "請求者氏名が退職者名と同一です。本人の場合は「請求区分」で「本人」を選択してください。「請求区分」が「遺族」または「相続人」の場合は請求者氏名を修正してください。",
    TKMSG_SCR0007W:
      "退職者の生年月日と請求者の生年月日が同一となっています。生年月日に誤りがないか確認してください。",
    TKMSG_SCR0038E:
      "振込先口座名義人名と請求者名が一致しないため、登録できません。入力内容をご確認ください。",
    TKMSG_SCR0008W:
      "ご本人名義の口座で間違いないかをご確認ください。問題無い場合は再度、「確認」ボタンを押下してください。",
    TKMSG_SCR0039E:
      "口座番号の桁数が7桁ではありません、入力内容をご確認ください。",
    TKMSG_SCR0009W:
      "共済契約者が退職届の退職理由で④犯罪退職による退職としている場合は、退職金の支給可否の審査を行うこととなるため、審査の結果、退職金が支給されないこともあること、審査には相応の時間を要することをご了承ください。",
    TKMSG_SCR0040E:
      "「希望する納付期限」を確認してください。「延長前の納付期限」より前の日付となっています。",
    TKMSG_SCR0041E:
      "災害救助法適用以外の場合は、「延長申請の理由証明書」は必須となります。「延長申請の理由証明書」を添付してください。",
    TKMSG_SCR0042E:
      "個人で加入している退職金制度がある場合は、「退職所得の源泉徴収票」を添付します（2枚まで）",
    TKMSG_SCR0043E: "入力してください",
    TKMSG_SCR0044E: "選択してください",
    TKMSG_SCR0045E: "{$1}文字以上で入力してください",
    TKMSG_SCR0046E: "{$1}文字以下で入力してください",
    TKMSG_SCR0047E: "{$1}以上の数字を入力してください",
    TKMSG_SCR0048E: "{$1}以下の数字を入力してください",
    TKMSG_SCR0049E: "YYYY/MM/DD形式で入力してください",
    TKMSG_SCR0050E: "{$1}以降の日付を入力してください",
    TKMSG_SCR0051E: "{$1}以前の日付を入力してください",
    TKMSG_SCR0052E: "半角英字のみ入力してください",
    TKMSG_SCR0053E: "半角数字のみ入力してください",
    TKMSG_SCR0054E: "半角カナのみ入力してください",
    TKMSG_SCR0055E: "半角英数カナのみ入力してください",
    TKMSG_SCR0056E: "半角英数記号のみ入力してください",
    TKMSG_SCR0057E: "半角のみ入力してください",
    TKMSG_SCR0058E: "全角英字のみ入力してください",
    TKMSG_SCR0059E: "全角数字のみ入力してください",
    TKMSG_SCR0060E: "全角カナのみ入力してください",
    TKMSG_SCR0061E: "全角のみ入力してください",
    TKMSG_SCR0098E: "200文字以下で入力してください",
    TKMSG_SCR0062E: "メールアドレスを正しく入力してください",
    TKMSG_SVR0002E:
      "育児休業期間が、契約対象外施設に異動している期間と重なっています。重ならない日付となるよう修正してください。",
    TKMSG_SVR0003E:
      "育児休業期間が、不就業期間（合算待ち期間）と重なっています。重ならない日付となるよう修正してください。",
    TKMSG_SVR0004E:
      "育児休業の取得回数が上限を超えています。内容を確認してください。",
    TKMSG_SVR0003W:
      "育児休業の半年延長回数が上限を超えています。内容を確認してください。",
    TKMSG_SVR0008E:
      "半年延長のチェックがある場合、「育児休業終了日」は、出生日の２年後を超える日付を入力できません。",
    TKMSG_SVR0004W:
      "登録した育児休業期間は正しいですか。正しい場合、「はい」を押してください。育児休業期間で「ならない月」にチェックがついている月はチェックを外します。育児休業期間に誤りがある場合には「いいえ」を押して、育児休業期間を修正してください。",
    TKMSG_SCR0013W:
      "育休期間が重なっています。第１子の「育児休業終了日」を第２子の「育児休業開始日」を重ならないよう修正してください。",
    TKMSG_SVR0005W:
      "掛金届で登録された本俸月額（俸給表の額＋俸給の調整額）と、退職届で登録された本俸月額が大幅に異なっています。誤りがないか確認してください。誤りがない場合はエビデンス資料（賃金台帳等）を添付し、退職届を提出してください。",
    TKMSG_SVR0014W:
      "6か月本俸の一番高い金額と低い金額の差が大きいため、誤りがないか確認してください。誤りがない場合はエビデンス資料（賃金台帳等）を添付し、退職届を提出してください。",
    TKMSG_SVR0015W:
      "6か月本俸の一番古い金額と直近の金額の差が大きいため、誤りがないか確認してください。誤りがない場合はエビデンス資料（賃金台帳等）を添付し、退職届を提出してください。",
    TKMSG_SCR0016W:
      "6か月本俸で入力がある月と、ない月があります。誤りがないか確認してください。誤りがない場合はエビデンス資料（賃金台帳等）を添付し、退職届を提出してください。",
    TKMSG_SCR0017W:
      "俸給表の額に比較して、俸給の調整額が著しく大きくなっています。誤りがないか確認してください。誤りがない場合はエビデンス資料（賃金台帳等）を添付し、退職届を提出してください。",
    TKMSG_SVR0009E:
      "入力された「加入日」が、前契約者の退職日翌日以外となっているため、「継続ではなく通常の加入」として扱います。",
    TKMSG_SVR0017E:
      "入力された「加入日」は前々年度の日付となっています。既に前々年度は確定してしまっているため、この日付で加入はできません。「加入日」を前年度４月２日以降に修正してください。",
    TKMSG_SVR0018E:
      "入力された「加入日」は前年度の日付となっています。既に当年度は確定してしまっているため、この日付で加入はできません。「加入日」を当年度４月２日以降に修正してください。",
    TKMSG_SVR0010E:
      "「新設・申出年月日」の入力日付では登録ができません。契約日の翌日以降の日付としてください。",
    TKMSG_SVR0019E:
      "入力された「新設・申出年月日」は前々年度の日付となっています。既に前々年度は確定してしまっているため、この日付で新設・申出はできません。「新設・申出年月日」を前年度４月２日以降に修正してください。",
    TKMSG_SVR0020E:
      "入力された「新設・申出年月日」は前年度の日付となっています。既に当年度は確定してしまっているため、この日付で新設・申出はできません。「新設・申出年月日」を当年度４月２日以降に修正してください。",
    TKMSG_SVR0011E:
      "当年度の掛金届が未提出です。先に掛金届を提出してください。",
    TKMSG_SVR0005E:
      "当年度の掛金届が未提出です。先に掛金届を提出してください。",
    TKMSG_SVR0012E: "すでに同一の施設が登録されています。",
    TKMSG_SVR0006W:
      "すでに同一の施設が登録されている可能性があります。登録内容をご確認ください。",
    TKMSG_SCR0067E:
      "給与支払遅延がある場合は申出の拒絶理由に該当するため、申込めません。",
    TKMSG_SCR0068E:
      "当該申込施設は、１年以内に部分解除したことが「有」の場合、法令に基づき「申出の拒絶理由」に該当し、申出を承諾できないため、申込めません。",
    TKMSG_SVR0013E:
      "該当施設は、「転換後非加入届」を提出しているため、転換日以降の「加入日」で新規加入はできません。",
    TKMSG_SVR0014E:
      "「加入日」が、非加入届又は部分解除を取り下げた日より前の日となっています。取り下げた日と同日以降で入力してください。",
    TKMSG_SVR0015E:
      "合算利用の期限がきれているため、合算加入ができません。引継ぎコードをつかわずに、新規加入として処理をしてください。",
    TKMSG_SVR0016E:
      "氏名、生年月日が同じ職員が加入済です。登録済みの職員を退職処理（退職予定日の入力）をしてから、新規加入処理をおこなってください。",
    TKMSG_SVR0007W:
      "氏名、生年月日が同じ職員が加入済です。契約対象外施設に所属している職員について、加入登録させたい場合は、復帰の手続きを行ってください。",
    TKMSG_SVR0006E:
      "登録されている退職者の情報と入力内容が一致しません。勤務先の共済契約者へ連絡して確認してください。",
    TKMSG_SVR0007E:
      "共済契約の解除（経営者でなくなった者の届）の処理がされているため、解除日よりあとの日付を「退職（予定）日」に入力できません。",
    TKMSG_SVR0021E:
      "施設の廃止日が設定されているため、廃止日よりあとの日付を退職日は入力できません。",
    TKMSG_SVR0001I:
      "登録された育休期間に「ならない月」の登録があったため、「ならない月」から除外しました。従業状況にて確認してください。",
    TKMSG_SVR0008W:
      "本届により、掛金額が増加しました。納付済の場合、追加納付が必要となります。内容を確認後、再度「登録」ボタンを押してください。",
    TKMSG_SVR0009W:
      "本届により、掛金額が減少しました。納付する掛金が減ります。内容を確認後、再度「登録」ボタンを押してください。",
    TKMSG_SVR0022E:
      "契約対象外施設への異動日から新設・申出日まで５年を経過しているため、配置換えが行えません。",
    TKMSG_SVR0023E:
      "譲渡された施設に、制度改正後加入者、部分解除後加入者、転換後の加入者は配置換えはできません。",
    TKMSG_SVR0024E:
      "在籍期間が１年未満の職員(職員番号:{$1})は、契約対象外施設等に配置換えできません。",
    TKMSG_SVR0025E:
      "当該職員は、加入止め、部分解除を行っている施設に配置換えができません。「契約対象外施設等異動」か「退職」のどちらかの処理が必要です。",
    TKMSG_SVR0026E:
      "転換後非加入届を提出している施設には、転換日以後の加入者は配置換えできません。",
    TKMSG_SVR0027E:
      "当該職員は、加入する施設が「非加入届」又は「部分解除」を取り下げた日と同日以降でなければ配置換えできません。",
    TKMSG_SVR0028E:
      "「配置換え日」は異動先施設の新設・申出日の翌日以降日付を入力してください。",
    TKMSG_SVR0029E:
      "入力された「配置換え日」は前年度の日付です。既に前年度は確定しているため、この日付での配置換えはできません。",
    TKMSG_SVR0030E:
      "入力された「配置換え日」は前年度の日付です。既に当年度は確定してしまっているため、この日付での加入はできません。「配置換え日」を当年度４月２日以降に修正してください。",
    TKMSG_SVR0031E:
      "経営移管により引き継いだ職員は、契約対象外施設に配置換えはできません。（引き継いだ施設間の配置換えは可能です）",
    TKMSG_SVR0032E:
      "当該職員は、契約対象外施設への異動日から加入日までの期間が５年を経過しているため、復帰できません。",
    TKMSG_SVR0033E:
      "合算利用の期限がきれているため、合算加入ができません。引継ぎコードをつかわずに、新規加入として処理をしてください。",
    TKMSG_SVR0011W:
      "転換後非加入届を提出している施設のため、転換日より後の「復帰日」での復帰はできません。このまま「処理を続ける」場合、【退職】となるため、退職届の提出が必要となります。【退職】の扱いとしない場合は「戻る」を押下し、配置換え先を変更してください。",
    TKMSG_SVR0034E:
      "入力された「復帰年月日」では復帰できません。復帰年月日を、対象施設の非加入届又は部分解除の取下げ日度同日以降の日付としてください",
    TKMSG_SVR0035E:
      "入力された「復帰年月日」では復帰できません。復帰年月日を、対象施設の新設・申出日の翌日以降の日付としてください",
    TKMSG_SVR0038E:
      "入力された「変更年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で施設種類の変更はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0039E:
      "入力された「変更年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、この日付で施設種類の変更はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0040E:
      "入力された「解除年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0041E:
      "入力された「解除年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0042E:
      "解除年月日より後の日付で、退職届が提出されているため、契約解除できません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0043E:
      "入力された「経営者でなくなった年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で契約解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0044E:
      "入力された「経営者でなくなった年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、この日付で契約解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0045E:
      "入力された「中小企業退職共済契約締結年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0046E:
      "入力された「中小企業退職共済契約締結年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0047E:
      "入力された「解除年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で部分解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0048E:
      "入力された「解除年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、この日付で部分解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0049E:
      "「解除年月日」より後の日付で、退職届が提出されているため、部分解除できません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0050E:
      "入力された「退職日」は前々年度の日付です。入力に誤りがない場合は、前年度の掛金返還が必要な場合があるため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0051E:
      "入力された「退職日」は前年度の日付です。入力に誤りがない場合は、当年度の掛金返還が必要な場合があるため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0052E:
      "共済契約の解除（経営者でなくなった者の届以外）の処理がされているため、当該日付以降で退職処理はできません。共済契約の解除（経営者でなくなった者の届以外）の提出前に退職処理を実施してください。",
    TKMSG_SVR0053E:
      "共済契約の解除（経営者でなくなった者の届）の処理がされているため、当該日付より後の日付で退職処理はできません。共済契約の解除（経営者でなくなった者の届）の解除日以前の日付を退職日としてください。",
    TKMSG_SVR0054E:
      "「施設の廃止日」が入力されているため、退職処理はできません。他の施設に配置換え処理を実施してから、退職処理をするか、退職日を「施設の廃止日」以前としてください。",
    TKMSG_SVR0055E: "申込者は、既に登録済の共済契約者です。",
    TKMSG_SVR0056E:
      "申込者は、過去に掛金未納による契約解除を行っています。内容を確認してください。",
    TKMSG_SCR0019W:
      "「加入日」が継続異動加入の要件をみたしていないため、「通常加入」（継続とならない）として扱われます。",
    TKMSG_SCR0020W:
      "申請に必要な必要書類が添付されていません。画面左上システムメニュー「三」ないの「退職状況一覧」から添付を実施してください。",
    TKMSG_SVR0012W:
      "配置換え先の施設は「加入止め」または「部分解除」を行っている施設となるため、復帰できません。このまま「処理を続ける」場合、【退職】となるため、退職届の提出が必要となります。【退職】の扱いとしない場合は「戻る」を押下し、配置換え先を変更してください。",
    TKMSG_SCR0069E:
      "「稟議決裁一覧登録」ボタンを押下する場合は、選択行の「申請・届出」を同一の業務のみにしてください。",
    TKMSG_SVR0057E:
      "契約解除（加入者全員の同意）の手続きが提出済のため、退職届の処理は実施できません。",
    TKMSG_SCR0001I:
      "平成27年4月1日以降に共済契約を締結した学校法人は、新規加入のお手続きはできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0070E: "開始日以降の終了日を入力してください。",
    TKMSG_SCR0002I: "検索条件に該当するデータはありません。",
    TKMSG_SVR0058E:
      "処理に時間がかかっています。申し訳ございませんが、時間をおいて再度お試しください。",
    TKMSG_SCR0071E: "同じ手当は選択できません。",
    TKMSG_SCR0072E: "ご本人名義の口座で間違いないかをご確認ください。",
    TKMSG_SCR0073E: "アルファベット以外の全角文字を入力してください。",
    TKMSG_SCR0021W:
      "退職手当金請求の時効が過ぎています。時効を放棄して退職手当金を支給するには決裁が必要です。",
    TKMSG_SCR0074E: "添付できる源泉徴収票の上限を超えています。",
    TKMSG_SVR0059E:
      "依頼中の帳票作成が出力エラーとなっています。システム管理者にお問い合わせください。",
    TKMSG_SVR0060E:
      "「俸給の調整額」対象手当の「上限金額」より「下限金額」が大きい値となっています。修正してください。",
    TKMSG_SVR0061E:
      "「俸給の調整額」対象手当の「手当区分」で「その他」を選んだ場合は、具体的な「申請手当名」も登録してください。",
    TKMSG_SVR0062E:
      "他申請で退職年月日より後に予定が入っているため、退職届の処理は実施できません。",
    TKMSG_SVR0063E:
      "部分解除した配置換え先の施設に対して、配置できない職員を選択しています。修正してください。",
    TKMSG_SVR0064E:
      "転換後非加入とした配置換え先の施設に対し、配置できない職員を選択しています。修正してください。",
    TKMSG_SVR0065E: "廃止済み施設に職員が登録されています。修正してください。",
    TKMSG_SVR0066E:
      "未提出の申請が残っています。一時保存中の申請をご確認ください。",
    TKMSG_SCR0075E:
      "「一括承認」ボタンを押下する場合は、選択行の「申請・届出」を同一業務かつ、状況が「上長承認待ち」のみにしてください。",
    TKMSG_SVR0016W:
      "ほかの申請で当該職員のデータが更新済みです。お手数ですが、画面を再表示後に、再入力をお願います。",
    TKMSG_SVR0067E: "いずれかの検索条件を入力してください。",
    TKMSG_SVR0017W: "条件に該当するデータはありません。",
    TKMSG_SCR0076E: "共済契約者番号か申請idのどちらかが必ず存在していること。",
    TKMSG_SVR0077E: "{$1}が取得できません。",
    TKMSG_SVR0078E: "{$1}はString型に変換できません。",
    TKMSG_SVR0079E: "{$1}はInteger型に変換できません。",
    TKMSG_SVR0080E: "{$1}はShort型に変換できません。",
    TKMSG_SVR0081E: "{$1}はDate型に変換できません。",
    TKMSG_SVR0082E: "{$1}はBigDecimal型に変換できません。",
    TKMSG_SVR0083E: "{$1}はbase64形式ではありません。",
    TKMSG_SVR0084E: "{$1}はTimestamp型に変換できません。",
    TKMSG_SVR0085E:
      "{$1}は有効な文字数ではありません。(対象文字数:{$2}、有効文字数:{$3})",
    TKMSG_SVR0086E:
      "{$1}は有効な文字数の範囲内ではありません。(対象文字数:{$2}、有効最小文字数:{$3}、有効最大文字数:{$4})",
    TKMSG_SVR0087E: "リストが空です。",
    TKMSG_SVR0088E:
      "取得した業務タイプの種類が複数あり、かつ業務タイプが退職手当金請求・退職手当金請求（追加支給）・退職手当金請求（再送金）以外が含まれている",
    TKMSG_SVR0089E: "{$1}は必須項目です。",
    TKMSG_SVR0090E:
      "{$1}は許容バイト数を超えています。(対象バイト数:{$2}、有効バイト数:{$3})",
    TKMSG_SVR0091E: "{$1}は数字ではありません。",
    TKMSG_SVR0092E: "{$1}は年月日(yyyy/MM/dd)形式ではありません。",
    TKMSG_SVR0093E: "{$1}は年月(yyyyMM)形式ではありません。",
    TKMSG_SVR0094E: "{$1}は年(yyyy)形式ではありません。",
    TKMSG_SVR0095E: "{$1}はカナ表記入力文字ではありません。",
    TKMSG_SVR0096E:
      "{$1}は有効な数値の範囲内ではありません。(対象:{$2}、最小値:{$3}、最大値:{$4})",
    TKMSG_SVR0018W:
      "引継ぎコードが使用できませんでした。コードを確認して、もう一度やり直してください。",
    TKMSG_SVR0097E:
      "ログインに失敗しました。ユーザーIDまたはパスワードが不正です。",
    TKMSG_SVR0098E:
      "参照されたアカウントは現在ロックされています。しばらくたってからアクセスしてください。",
    TKMSG_SVR0099E:
      "パスワードの有効期限が切れてます。再度パスワードを設定してください。",
    TKMSG_SVR0100E:
      "「送信期間From」が「送信期間To」より後の日時なので、ご確認ください。",
    TKMSG_SVR0101E: "{$1}はメールアドレスの形式ではありません。",
    TKMSG_SVR0102E: "{$1}は職種コードに存在しません。",
    TKMSG_SVR0103E: "{$1}は都道府県コードに存在しません。",
    TKMSG_SVR0104E: "{$1}は電話番号の形式ではありません。",
    TKMSG_SVR0105E:
      "コード値「{$1}」は存在しません。(コード名:{$2}、コードタイプ:{$3})",
    TKMSG_SVR0106E: "{$1}はフラグの形式(" + 0 + "," + 1 + ")ではありません。",
    TKMSG_SVR0107E: "{$1}は月(1～12)の形式ではありません。",
    TKMSG_SVR0108E: "{$1}は収納状態ではありません。",
    TKMSG_SVR0109E: "{$1}は2(入金済み)ではありません。",
    TKMSG_SVR0110E: "{$1}は16桁を超えています。",
    TKMSG_SVR0111E: "{$1}は正の値ではありません。",
    TKMSG_SVR0112E: "退職届を先に提出してください。",
    TKMSG_SCR0077E: "{$1}文字で入力してください",
    TKMSG_SVR0113E: "次の担当者を特定できません。",
    TKMSG_SVR0114E: "対象のレコードがありません。(テーブル:{$1})",
    TKMSG_SVR0115E:
      "解除日より前が退職日の退職者について、退職届が未提出です。先に退職届の提出をおこなってください。また、退職日が解除日以降の日付で登録されている職員がいる場合は、「従業状況の登録」画面で退職日の削除を行ってください。",
    TKMSG_SVR0116E:
      "現在の申請状況を担当できないユーザを選択しています。ユーザの権限をご確認ください。",
    TKMSG_SVR0117E:
      "制度改正後加入させない届出を出している施設に、制度改正後に加入した職員を配置換えすることはできません。",
    TKMSG_SVR0019W:
      "入力されたパスワードは不正です。異なるパスワードを入力してください。",
    TKMSG_SVR0020W: "入力されたシステム利用者IDは登録済みです。",
    TKMSG_SVR0021W: "自身が担当している申請以外を承認するはできません。",
    TKMSG_SVR0118E: "退職届を出すことができない契約者又は施設に属しています。",
    TKMSG_SCR0078E: "再入力されたパスワードが一致していません。",
    TKMSG_SCR0079E: "入力内容が不正です。",
    TKMSG_SCR0080E: "桁数が不正です。",
    TKMSG_SCR0081E: "拡張子が不正です。",
    TKMSG_SVR0119E: "入力されたユーザidの有効期限が切れています。",
    TKMSG_SVR0120E:
      "退職届の退職理由が「④犯罪退職による退職」として承認されたため、退職手当金の請求がおこなえません。",
    TKMSG_SVR0121E:
      "退職手当金請求書がすでに受理されているため、被共済職員退職届の取り下げは行えません。",
    TKMSG_SCR0082E: "項目数が不正です。",
    TKMSG_SCR0083E: "新担当者名を１件以上選択してください。",
    TKMSG_SVR0122E: "{$1}は外部IFコードに存在しません。",
    TKMSG_SVR0123E: "振込依頼FBデータ出力の場合、申請idは必須です。",
    TKMSG_SVR0124E:
      "宛先出力の場合、出力させる宛名情報（外部IF宛名モデル）は必須です。",
    TKMSG_SCR0084E: "YYYY/MM形式で入力してください",
    TKMSG_SCR0085E: "配置換え入力を行ってください。",
    TKMSG_SVR0022W:
      "稟議決裁一覧登録を行い、グループ申請として承認してください。",
    TKMSG_SVR0125E:
      "当該申請の申請状態から実行できる申請イベントではありません。",
    TKMSG_SCR0003I:
      "現在、作成中です。ダウンロードが可能となりましたらお知らせします",
    TKMSG_SVR0023W: "作成者以外が更新することはできません。",
    TKMSG_SVR0126E:
      "検索結果表示対象件数が多いため、一部の結果のみ表示しています。検索条件を追加し、対象件数をしぼってください。",
    TKMSG_SCR0086E:
      "希望する延長期限日付には、延長前の納付期限以降の日付を入力してください。",
    TKMSG_SVR0127E: "入金予定日は、交付決定日以下の日付を入力できません。",
    TKMSG_SCR0087E: "選択された手続きは、督促日を設定できません。",
    TKMSG_SCR0088E: "1件ずつ選択してください。",
    TKMSG_SCR0089E:
      "入力された「中小企業退職共済契約締結年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0090E:
      "入力された「中小企業退職共済契約締結年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0091E:
      "入力された「解除年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で部分解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0092E:
      "入力された「解除年月日」は当年度の日付となっています。既に当年度は確定してしまっているため、この日付で部分解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0112E: "翌年度以降の解除年月日は入力できません。",
    TKMSG_SCR0093E: "半角英数のみ入力してください",
    TKMSG_SVR0128E: "時刻が不正です。",
    TKMSG_SVR0129E:
      "加入日が当該施設の新設・申出日の翌日以降でなければ加入できません。新設・申出日の翌日以降の日付を入力してください。",
    TKMSG_SVR0130E:
      "加入日が当該共済契約者の契約日の翌日以降でなければ加入できません。契約日の翌日以降の日付を入力してください。",
    TKMSG_SVR0131E:
      "登録済みの施設名と入力された施設名が一致していません。施設名を見直してください。",
    TKMSG_SVR0132E:
      "登録済みの共済契約者名と入力された共済契約者名が一致していません。共済契約者名を見直してください。",
    TKMSG_SVR0133E:
      "退職届が「取り下げ」となっているため、申請ができません。勤務先の共済契約者へ連絡して確認してください。",
    TKMSG_SVR0134E:
      "「申請id」または、「法人職員番号」のいずれかは一つは必須です。",
    TKMSG_SCR0094E: "施設を選択してください。",
    TKMSG_SCR0095E:
      "送信期間（TO）には送信期間（FROM）よりも未来の日付を入力してください。",
    TKMSG_SCR0096E:
      "「宛名印刷」を選択する場合は、他のファイルを同時に選択できません",
    TKMSG_SCR0097E: "「読み込み」ボタンを押してください。",
    TKMSG_SVR0139E: "加入日よりも前の月は、「ならない月」の登録はできません。",
    TKMSG_SVR0140E:
      "加入日よりも前の日付を、「退職（予定）日」に登録できません。",
    TKMSG_SCR0099E: "「申請・届出」を選択してください。",
    TKMSG_SVR0141E:
      "当該申込施設は、１年以内に部分解除したことが「有」の場合、法令に基づき「申出の拒絶理由」に該当し、申出を承諾できないため、申込めません。",
    TKMSG_SVR0142E: "当該申請の担当者ではないため、処理できません。",
    TKMSG_SVR0135E:
      "バッチ更新処理でエラーが発生しました。ログを確認してください。",
    TKMSG_SVR0137E:
      "「一括承認」ボタンを押下する場合は、選択行の「申請・届出」を同一業務かつ、状況が「上長承認待ち」または「課長代理確認待ち」の一方のみにしてください。",
    TKMSG_SVR0138E: "バッチ処理でエラーが発生しました。（参考情報：{$1}）",
    TKMSG_SVR0136E:
      "「稟議決裁一覧登録」ボタンを押下する場合は、選択行の「申請・届出」を同一のグループ化可能な業務のみにしてください。",
    TKMSG_SVR0143E: "グループ化されている申請の手続きが進んでいません。",
    TKMSG_SCR0100E: "稟議決裁一覧登録の対象では無い申請が含まれています。",
    TKMSG_SVR0144E: "既に利用されている記号番号です。",
    TKMSG_SVR0145E:
      "今年度の本俸月額更新が登録されていない職員がいます。前画面にもどり、「確認７.４月１日現在の俸給額に更新されていますか？」を「いいえ」にして今年度の本俸月額に更新してください。",
    TKMSG_SVR0146E:
      "入力いただいた加入年月日では登録できません。入力した日付に誤りがないか確認してください。",
    TKMSG_SCR0101E:
      "俸給額が登録されていない職員がいます。「職員の更新」を「修正」して更新を行ってください。",
    TKMSG_SVR0147E: "当年度の掛金届を提出してから、退職届をご提出ください。",
    TKMSG_SVR0148E: "出勤日数が正しくありません。",
    TKMSG_SCR0102E: "契約者名称の変更年月日を入力してください。",
    TKMSG_SCR0103E: "変更後の契約者名を入力してください。",
    TKMSG_SCR0104E: "履歴事項全部証明書（写）を添付してください。",
    TKMSG_SCR0105E: "主たる事務所の所在地の変更年月日を入力してください。",
    TKMSG_SCR0106E: "変更後の主たる事務所の所在地を入力してください。",
    TKMSG_SCR0107E:
      "変更内容の入力、または共済契約証書再交付申出の「有」を選択してください。",
    TKMSG_SCR0108E:
      "入力された「解除年月日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0109E:
      "入力された「解除年月日」は前年度以前の日付となっています。既に当年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0149E: "権限がありません。",
    TKMSG_SVR0150E: "電話番号の桁数が14桁を超えています。",
    TKMSG_SVR0151E: "申出施設のみでの新規契約のお申込みはできません。",
    TKMSG_SVR0152E: "本文のURLを編集することはできません。",
    TKMSG_SVR0153E:
      "当該職員は入力された「配置換え先施設の配属日」以降の日付で配置換え・異動等を行っているため、この日付で登録はできません。",
    TKMSG_SVR0154E:
      "当該職員には入力された「配置換え先施設の配属日」以降の日付で解除・異動等の申請が一時保存中であるため、この日付で登録はできません。該当する申請を取り下げるか、他の日付で入力してください。",
    TKMSG_SVR0155E:
      "当該職員は入力された「配置換え先施設の配属日」以降の日付で退職予定日が入力されているため、この日付で登録はできません。従業状況一覧から退職予定日を削除するか、他の日付で入力してください。",
    TKMSG_SVR0156E:
      "共済契約の解除（全員同意）の処理がされているため、解除日よりあとの日付を「退職（予定）日」に入力できません。",
    TKMSG_SCR0110E: "ならない月を確定してください。",
    TKMSG_SCR0113E: "契約対象外施設は選択できません。",
    TKMSG_SVR0157E: "退職手当金請求の上長承認後に実施してください。",
    TKMSG_SVR0158E:
      "入力された「休止・廃止経営移管年月日」以降の日付で当施設から適用外施設に異動した職員がいるため、この日付で廃止・休止・経営移管はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0159E:
      "入力された「休止・廃止経営移管年月日」以降の日付で適用外施設から当施設に復帰した職員がいるため、この日付で廃止・休止・経営移管はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0160E:
      "入力された「中小企業退職共済契約締結年月日」以降の日付で適用外施設に異動した職員がいるため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0161E:
      "入力された「中小企業退職共済契約締結年月日」以降の日付で適用外施設から復帰した職員がいるため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0162E:
      "入力された「経営者でなくなった年月日」以降の日付で当施設から適用外施設に異動した職員がいるため、この日付で登録はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0163E:
      "入力された「経営者でなくなった年月日」以降の日付で適用外施設から当施設に復帰した職員がいるため、この日付で登録はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0164E:
      "入力された「解除年月日」以降の日付で当施設から適用外施設に異動した職員がいるため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0165E:
      "入力された「解除年月日」以降の日付で適用外施設から当施設に復帰した職員がいるため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0166E:
      "選択された解除対象となる職員の範囲に対して、解除できる職員が存在しません。",
    TKMSG_SVR0167E:
      "選択された申請の中から、【留保フラグ】が立っている職員の申請を除いて処理しました。",
    TKMSG_SVR0168E:
      "休止・廃止・経営移管年月日より後の日付で、退職届が提出されているため、廃止休止処理ができません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0111E: "選択された手続きは、請求放棄できません。",
    TKMSG_SVR0169E:
      "解除同意書の人数と解除対象となる職員数が一致しません。「部分解除対象施設一覧」画面から解除情報の削除を行い、再度登録しなおしてください。",
    TKMSG_SVR0170E:
      "入力された「解除年月日」以降の日付で異動する職員がいるため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0171E:
      "解除年月日より後の日付で、退職届が提出されているため、部分解除できません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0172E:
      "訂正前もしくは訂正後の「加入年月日」は直近5年度分以外の掛金情報が変わってしまうため変更出来ません。",
    TKMSG_SVR0173E:
      "すでに依頼が済んでいる代行内容です。代行施設または代行内容を確認してください。",
    TKMSG_SVR0174E:
      "取り下げようとしている退職届の退職日は、掛金確定済年度の日付となるため「取下げ」ができません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0175E:
      "取り下げようとしている退職届の在籍施設が、廃止・解除対象となるため「取下げ」ができません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0176E:
      "退職手当金が請求放棄されているため、申請できません。機構へお問い合わせ下さい。",
    TKMSG_SVR0177E:
      "掛金届が未提出の年度で配置換えはできません。「配置換え先施設の配属日」を当年度４月２日から翌年度４月２日までの間で入力してください。",
    TKMSG_SVR0178E:
      "掛金届が未提出の年度で配置換えはできません。「配置換え先施設の配属日」を前年度４月２日から当年度４月２日までの間で入力してください。",
    TKMSG_SVR0179E: "この業務の申請は共済契約者に差戻せません。",
    TKMSG_SVR0180E:
      "確定済の年度で廃止・休止・経営移管はできません。「廃止・休止・経営移管年月日」を前年４月１日以降で入力してください。",
    TKMSG_SVR0181E:
      "未確定、確定済、または掛金届提出済の年度で廃止・休止・経営移管はできません。「廃止・休止・経営移管年月日」を当年度４月２日から翌年度４月１日までの間で入力してください。",
    TKMSG_SVR0182E:
      "入力された引継ぎコードは機構の承認が下りていないため使用出来ません。",
    TKMSG_SVR0183E:
      "未確定または確定済の年度で加入はできません。「加入日」を前年度４月２日から当年度４月１日までの間で入力してください。",
    TKMSG_SVR0184E:
      "未確定、確定済、または掛金届提出済の年度で加入はできません。「加入日」を当年度４月２日から翌年度４月１日までの間で入力してください。",
    TKMSG_SVR0185E:
      "不正なメールアドレスが入力されています。確認の上、正しいメールアドレスを入力してください。",
    TKMSG_SCR0114E:
      "職員情報が登録中の施設があります。「職員情報登録」ボタンを押下し、職員情報の登録を完了してください。",
    TKMSG_SCR0115E:
      "「育児休業終了（予定）日」は、「出生日」以降の日付を入力してください。",
    TKMSG_SCR0116E:
      "「育児休業終了（予定）日」は、「育児休業開始日」以降の日付を入力してください。",
    TKMSG_SVR0186E:
      "「源泉徴収票の再発行依頼」は、退職金請求が完了していないので依頼できません。",
    TKMSG_SVR0187E:
      "「新規契約情報入力」を進められる対象の法人ではありません。",
    TKMSG_SVR0188E:
      "選択中の職員が所属している施設で共済契約対象施設等一部廃止届を提出した場合、または共済契約者でなくなったものの届を提出したことによる配置換えの場合、「配置換え先施設の配属日」は解除年度の４月２日から解除日の翌日までの間で入力してください。",
    TKMSG_SVR0189E:
      "加入している職員数を超えているため、入力内容を確認してください。",
    TKMSG_SVR0190E:
      "契約対象外施設への異動の申請が、対応が必要な手続きに存在する職員を含んでいます。該当の手続きを先に実施してください。",
    TKMSG_SVR0191E:
      "契約対象施設への復帰の申請が、対応が必要な手続きに存在する職員を含んでいます。該当の手続きを先に実施してください。",
    TKMSG_SVR0192E:
      "契約対象外施設への異動の申請が、機構へ申請中の職員を含んでいます。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0193E:
      "俸給の登録が完了していない職員がいます。俸給を登録してください。",
    TKMSG_SCR0117E:
      "入力された「解除年月日」は翌年度以降の日付となっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0118E:
      "入力された「中小企業退職共済契約締結年月日」は翌年度以降の日付となっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0119E:
      "入力された「経営者でなくなった年月日」は前々年度以前の日付となっています。既に前年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0120E:
      "入力された「経営者でなくなった年月日」は前年度以前の日付となっています。既に当年度は確定してしまっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SCR0121E:
      "入力された「経営者でなくなった年月日」は翌年度以降の日付となっているため、この日付で解除はできません。画面下部の問い合わせフォームから機構へ相談してください。",
    TKMSG_SVR0194E:
      "該当施設で申請中または提出済みの「退職手当共済契約部分解除通知書」があるため、解除日より後の「加入日」で新規加入はできません。",
    TKMSG_SCR0122E:
      "入力された生年月日は加入日以降の日付となっています。入力内容に誤りがないかご確認ください。",
    TKMSG_SCR0123E:
      "「加入年月日」は、「被共済職員でなくなった年月日」よりも後の日付で入力してください。",
    TKMSG_SVR0195E:
      "異動履歴が不整合データなので、運用に問い合わせしてください。",
    TKMSG_SVR0196E:
      "これまで勤務されていた法人（共済契約者）において、源泉徴収票を後で添付することを選択いただいているため、合算制度の利用ができません。勤務されていた法人（共済契約者）に源泉徴収票を「不要」と改めて登録するようご連絡ください。法人での操作が完了後、合算制度の利用の手続きを進められることができます。",
    TKMSG_SCR0124E:
      "俸給の額が73,999円以下となっています。入力内容が正しいかご確認ください。入力内容が正しい場合は、機構へお問い合わせ下さい。",
    TKMSG_SVR0197E:
      "経過措置適用被共済職員期間が被共済職員期間より大きいです。退職金の金額に影響が生じる可能性がありますので、再度、受理を実施ください。",
    TKMSG_SVR0198E:
      "被共済職員期間と経過措置適用被共済職員期間の差が、退職日と制度改正基準日の差より大きいです。退職金の金額に影響が生じる可能性がありますので、再度、受理を実施ください。",
    TKMSG_SVR0199E:
      "アクセスの有効期限が切れましたので、もう一度お問い合わせをお願いいたします。",
    TKMSG_SCR0125E:
      "入力された退職所得に係る情報は、機構と重複した勤務期間がないため入力や添付は不要です。就労年月日、退職年月日に誤りがない場合には、前の画面に戻り「すべて登録されていることを確認」ボタンを押下して次へ進んでください。",
    TKMSG_SCR0126E: "チャットボットから手続きは行えません。",
    TKMSG_SCR0004I: "代行依頼が取消されているので作業不要です。",
    TKMSG_SVR0200E:
      "復帰期限を超過した職員（職員番号：{$1}）がいるため登録できません。",
    TKMSG_SVR0999E: "この操作は実行できません。運用担当者にご連絡ください。",
    TKMSG_SVR0201E: "掛金届の提出期間外です。４月１日以降に提出してください。",
    TKMSG_SCR0127E:
      "氏名が変更されている場合は、変更されていることが確認できる書類（戸籍抄本/免許証（表裏）/旧姓と新姓が確認できる住民票）もアップロードしてください。",
    TKMSG_SVR0202E:
      "前年度３月３１日以前の退職（予定）日を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、退職（予定）日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0203E:
      "前年度３月３１日以前の退職（予定）日を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、退職（予定）日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0204E:
      "前年度３月３１日以前の退職（予定）日を登録しようとしています。既に当年度は確定しているため、前年度３月３１日以前の退職（予定）日の変更はできません。当年度４月１日以降の退職（予定）日で登録してください。",
    TKMSG_SVR0205E:
      "前年度３月３１日以前の解除年月日を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、契約解除（加入者全員の同意）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0206E:
      "前年度３月３１日以前の解除年月日を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、契約解除（加入者全員の同意）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0207E:
      "前年度３月３１日以前の解除年月日を登録しようとしています。既に当年度は確定しているため、当年３月３１日以前で契約解除（加入者全員の同意）はできません。当年度４月１日以降日付で処理を行ってください。",
    TKMSG_SVR0208E:
      "前年度３月３１日以前の「経営者でなくなった年月日」を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、契約解除（経営者でなくなった）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0209E:
      "前年度３月３１日以前の「経営者でなくなった年月日」を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、契約解除（経営者でなくなった）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0210E:
      "前年度３月３１日以前の「経営者でなくなった年月日」を登録しようとしています。既に当年度は確定しているため、当年３月３１日以前で契約解除（経営者でなくなった）はできません。当年度４月１日以降日付で処理を行ってください。",
    TKMSG_SVR0211E:
      "前年度３月３１日以前の「契約解除年月日」を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、契約解除（中小企業退職金共済契約締結）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0212E:
      "前年度３月３１日以前の「契約解除年月日」を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、契約解除（中小企業退職金共済契約締結）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0213E:
      "前年度３月３１日以前の「契約解除年月日」を登録しようとしています。既に当年度は確定しているため、当年３月３１日以前で契約解除（中小企業退職金共済契約締結）はできません。当年度４月１日以降日付で処理を行ってください。",
    TKMSG_SVR0214E:
      "前年度３月３１日以前の「解除年月日」を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、契約解除（部分解除）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0215E:
      "前年度３月３１日以前の「解除年月日」を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、契約解除（部分解除）を行ってください。その後、掛金届を再提出してください。",
    TKMSG_SVR0216E:
      "前年度３月３１日以前の「解除年月日」を登録しようとしています。既に当年度は確定しているため、当年３月３１日以前で契約解除（部分解除）はできません。当年度４月１日以降日付で処理を行ってください。",
    TKMSG_SVR0217E:
      "前年度３月３１日以前の退職日を登録しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、退職日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0218E:
      "前年度３月３１日以前の退職日を登録しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、退職日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0219E:
      "前年度３月３１日以前の退職日を登録しようとしています。既に当年度は確定しているため、前年度３月３１日以前の退職日の変更はできません。当年度４月１日以降の退職日で登録してください。",
    TKMSG_SVR0220E:
      "入力された「加入日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、加入届を提出してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0221E:
      "入力された「加入日」が当年４月１日以前となっています。既に当年度の掛金届が提出済です。機構にFAXやお問い合わせフォームで至急ご連絡ください。",
    TKMSG_SVR0222E:
      "入力された「加入日」が当年４月１日以前となっています。既に当年度は確定しているため、当年４月１日以前の加入日での加入はできません。当年４月２日以降の加入日で登録してください。",
    TKMSG_SVR0223E:
      "入力された「新設・申出年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、施設新設の届を提出してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0224E:
      "入力された「新設・申出年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、施設新設の届を提出してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0225E:
      "入力された「新設・申出年月日」が当年４月１日以前となっています。既に当年度は確定しているため、当年４月１日以前の施設新設はできません。当年４月２日以降の「新設・申出年月日」で登録してください。",
    TKMSG_SVR0226E:
      "入力された「配置換え日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、配置換えを実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0227E:
      "入力された「配置換え日」が当年４月１日以前となっています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、配置換えを実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0228E:
      "入力された「配置換え日」が当年４月１日以前となっています。既に当年度は確定しているため、当年４月１日以前の配置換えはできません。当年４月２日以降の「配置換え日」で登録してください。",
    TKMSG_SVR0229E:
      "入力された「変更年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、施設区分変更を実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0230E:
      "入力された「変更年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、施設区分変更を実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0231E:
      "入力された「配置換え日」が当年４月１日以前となっています。既に当年度は確定しているため、当年４月１日以前の施設区分が変わる変更はできません。当年４月２日以降の「配置換え日」で登録してください。",
    TKMSG_SVR0232E:
      "正しい退職（予定）日になっているか従業状況更新からもう一度ご確認ください。",
    TKMSG_SCR0024W:
      "1年以上先の「廃止・休止・経営移管年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0025W:
      "1年以上先の「解除年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0026W:
      "1年以上先の「配置換え先施設の配属日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0027W:
      "1年以上先の「加入年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0028W:
      "1年以上先の「新設・申出年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0029W:
      "1年以上先の「退職年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0030W:
      "1年以上先の「退職（予定）日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0031W:
      "1年以上先の「退職（予定）日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0032W:
      "1年以上先の「解除年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0033W:
      "1年以上先の「中小企業退職共済契約締結年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SCR0034W:
      "1年以上先の「経営者でなくなった年月日」が入力されています。入力内容に誤りが無い場合は「確認」ボタンを押下してください。",
    TKMSG_SVR0233E:
      "入力された「廃止・休止・経営移管年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、一部廃止を実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0234E:
      "入力された「廃止・休止・経営移管年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、一部廃止を実施してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0235E:
      "入力された「廃止・休止・経営移管年月日」が当年４月１日以前となっています。既に当年度は確定しているため、当年４月１日以前の一部廃止はできません。当年４月２日以降の「廃止・休止・経営移管年月日」で登録してください。",
    TKMSG_SVR0236E:
      "該当施設は申請中の施設新設のものとなります。手続きの「申請状態」がかわったため、ホーム画面に戻り、再度「本俸月額更新」を開始してください。",
    TKMSG_SVR0237E:
      "掛金届が提出済年度の俸給が更新対象となっています。提出した掛金届に対し「取下」ボタンから取り下げた上で、俸給を登録してください。",
    TKMSG_SVR0238E: "同年度の掛金届がすでに提出済です。",
    TKMSG_SVR0239E:
      "すでに契約解除申請がでている共済契約者について、掛金届を提出しようとしています。本年度の掛金届の提出は不要です。",
    TKMSG_SVR0240E: "対象職員の退職届の申請処理がすでに存在します。",
    TKMSG_SVR0241E:
      "対象職員は他法人で合算加入の手続きが開始しているため、退職届の取下げはできません。",
    TKMSG_SVR0242E:
      "対象職員は他法人で合算加入の手続きが開始しているため、退職手当金の請求に切り替えることはできません。",
    TKMSG_SVR0243E: "対象職員の退職手当金請求の申請処理がすでに存在します。",
    TKMSG_SVR0244E: "対象職員の合算申出の申請処理がすでに存在します。",
    TKMSG_SVR0245E:
      "共済契約対象施設等一部廃止等届で配置換えを選択し、配置換え先の登録が未完了の職員が存在します。配置換えの登録を行ってください。",
    TKMSG_SVR0246E:
      "掛金届が提出済年度の従業状況を更新しようとしています。提出した掛金届に対し「再提出」ボタンから差し戻した上で、登録してください。",
    TKMSG_SVR0247E:
      "一時保存中の施設等の新設の申請が残っています。一時保存中の申請をご確認ください。4月1日以前が新設日の施設がある場合は、「施設等の新設」を実施してから掛金届を提出してください。",
    TKMSG_SVR0248E:
      "「休止・廃止経営移管年月日」より先日付で、新設施設への「配置換え」が登録されています。新設施設への配置換えを削除するか、「休止・廃止経営移管年月日」を変更してください。（「施設等の新設」届が機構へ提出済の場合は、機構へ連絡し「差戻し」を依頼してください。）",
    TKMSG_SVR0249E:
      "入力された「休止・廃止経営移管年月日」では廃止手続きができません。「休止・廃止経営移管年月日」を変更してください。（「休止・廃止経営移管年月日」より先日付が「新設・申出年月日」の新設施設へ「配置換え」登録されています。）",
    TKMSG_SVR0250E:
      "入力された「休止・廃止経営移管年月日」では廃止手続きができません。「休止・廃止経営移管年月日」を契約中施設の「新設・申出年月日」の前日以降とする必要があります。",
    TKMSG_SVR0251E:
      "入力された「休止・廃止経営移管年月日」では廃止手続きができません。「休止・廃止経営移管年月日」より先日付が「新設・申出年月日」の新設施設申請があります。施設新設届を取り下げてから廃止届を提出してください。",
    TKMSG_SVR0252E:
      "退職予定日に、当該施設の「新設・申出年月日」より前日付が入力されています。退職予定日は当該施設の「新設・申出年月日」以降としてください。",
    TKMSG_SVR0253E: "無効なURLです。URLを確認してください。",
    TKMSG_SVR0254E:
      "前年度３月３１日以前の退職日を変更しようとしています。既に当年度の掛金届が提出済のため、提出した掛金届に対し「再提出」ボタンから差し戻した上で、退職日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0255E:
      "前年度３月３１日以前の退職日を変更しようとしています。既に当年度の掛金届が提出済です。機構に連絡し、提出した掛金届を差し戻ししてもらった上で、退職日を変更してください。その後、掛金届を再提出してください。",
    TKMSG_SVR0256E:
      "前年度３月３１日以前の退職日を変更しようとしています。既に当年度は確定しているため、前年度３月３１日以前の退職日の変更はできません。当年度４月１日以降の退職日で登録してください。",
    TKMSG_SVR0257E:
      "加入日から退職日までの期間が1年未満であるため、退職手当金請求書・合算制度利用申出書は提出できません。",
    TKMSG_SVR0258E:
      "被共済職員期間が12か月未満であるため、退職手当金請求書は提出できません。",
    TKMSG_SVR0259E:
      "入力された「廃止・休止・経営移管年月日」よりも後に加入した職員が存在します。加入日よりも前の日付を「廃止・休止・経営移管年月日」に登録できません。",
    TKMSG_SVR0260E:
      "入力された変更年月日よりも前に解除または廃止とする日付の申請があります。入力された変更年月日をもう一度ご確認ください。",
    TKMSG_SVR0261E:
      "アップロードされたCSVに登録が確認できない職員番号が含まれています。入力内容をご確認のうえもう一度CSVアップロードを行ってください。",
    TKMSG_SVR0262E:
      "入力された退職年月日より後に他申請で予定が入っている職員が存在するため、登録できません。入力された退職年月日をもう一度ご確認ください。",
    TKMSG_SVR0263E:
      "入力内容が不正です。\n　退職者名（漢字及びフリガナ）は共済契約者から受領した「退職手当金請求コード」の書面に記載されている内容で入力してください。\n　また、退職金請求書を一時保存済みの場合、この画面で入力いただけるメールアドレスは退職金請求書に記載したメールアドレスとなりますので、ご注意ください。",
    TKMSG_SVR0264E: "当該申請はすでに提出済みです。",
    TKMSG_SVR0265E:
      "施設廃止で配置換えを選択した上で、配置換えが完了していない職員がいます。該当の職員の配置換えを完了させた後、掛金納付対象職員届を提出し直してください。",
    TKMSG_SVR0266E:
      "選択された申請の中から、【重複して提出された退職手当金請求書】の申請を除いて処理しました。情報システム管理課に連絡してください。",
    TKMSG_SVR0267E:
      "選択された申請の中から、【留保フラグ】が立っている職員の申請と【重複して提出された退職手当金請求書】の申請を除いて処理しました。情報システム管理課に連絡してください。",
    TKMSG_SVR0268E:
      "入力された「経営者でなくなった年月日」よりも後に加入した職員が存在します。加入日よりも前の日付を「経営者でなくなった年月日」に登録できません。",
    TKMSG_SVR0269E:
      "該当施設は申請中の施設新設のものとなります。来年度の俸給は、機構による承認完了後に更新してください。",
    TKMSG_SVR0270E:
      "前契約者での退職処理が完了していないため引継ぎコードが使用できません。機構へお問い合わせ下さい。",
    TKMSG_SVR0271E:
      "当該施設に登録された職員の中に入力された「新設・申出年月日」以降の日付で異動が登録されている職員がいるため、この日付で新設はできません。",
    TKMSG_SVR0272E:
      "継続異動の職員が登録中のため、「新設・申出年月日」を変更することはできません。",
    TKMSG_SVR0273E:
      "合算加入の職員が登録中のため、当該職員の退職日以前の日付で新設はできません。",
    TKMSG_SVR0274E:
      "合算加入の職員が登録中のため、当該職員の退職日から３年を超える日付で新設はできません。",
    TKMSG_SVR0275E:
      "在籍期間が１年以上の職員は「継続異動減」を選択できません。",
    TKMSG_SVR0276E:
      "在籍期間が１年未満の職員は「合算申出減」を選択できません。",
    TKMSG_SVR0277E:
      "被共済職員退職届がすでに受理されているため、取り下げは行えません。",
    TKMSG_SVR0278E:
      "被共済職員退職届がすでに取り下げまたは差戻されているため、追加の取り下げは行えません。",
    TKMSG_SVR0279E:
      "退職者ユーザーが存在しません。退職届を取り下げて再度提出を行ってください。",
    TKMSG_SVR0280E:
      "廃止済みの施設から配置換えした職員が登録中のため、「新設・申出年月日」は廃止日を含む年度の４月２日から廃止日の翌日までの間で入力してください。",
    TKMSG_SVR0281E:
      "新設施設への「配置換え」が登録されている職員がいます。配置換えを削除するか、施設新設届の承認完了後に手続きを進めてください。",
    TKMSG_SVR0282E:
      "当該施設は一部廃止の手続き中です。一部廃止の申請を削除するか、機構による承認完了後に手続きを進めてください。",
    TKMSG_SVR0284E:
      "共済契約者連絡先が登録されていないため、メールを送信することができません。",
    TKMSG_SVR0285E:
      "入力途中の申請があります。手続きを最初からやり直してください。",
    TKMSG_SVR0286E:
      "経営移管の施設または継続異動の職員が登録中のため、「契約締結日」を変更することはできません。",
    TKMSG_SVR0287E:
      "合算加入の職員が登録中のため、当該職員の退職日以前の日付で新規契約はできません。",
    TKMSG_SVR0288E:
      "合算加入の職員が登録中のため、当該職員の退職日から３年を超える日付で新規契約はできません。",
    TKMSG_SVR0289E:
      "入力された「契約締結日」は前々年度の日付となっています。既に前々年度は確定してしまっているため、この日付で新規契約はできません。「契約締結日」を前年度４月２日以降に修正してください。",
    TKMSG_SVR0290E:
      "入力された「契約締結日」は前年度の日付となっています。既に前年度は確定してしまっているため、この日付で新規契約はできません。「契約締結日」を当年度４月２日以降に修正してください。",
    TKMSG_SVR0291E:
      "不着明細アップロードエラーとなっています。システム管理者にお問い合わせください。",
    TKMSG_SVR0292E:
      "予期せぬ操作が行われました。連携されたURLから再度ログインしてください。",
    TKMSG_SVR0293E:
      "取下げ日は転換日・制度改正日・解除年月日以降の日付で入力してください。",
    TKMSG_SCR0128E:
      "対象職員は移行時点で合算済のため、システムから退職手当金の請求に切り替えることはできません。退職手当金の請求が必要な場合、運用に問い合わせしてください。",
    TKMSG_SCR0295E: "「退職者も検索」のみを選択して検索することはできません。",
    TKMSG_SVR0296E: "加入年月日は退職予定日の翌日以降で入力してください。",
    TKMSG_SVR0297E:
      "加入年月日は前法人での退職日の翌日以降で入力してください。",
    TKMSG_SVR0298E:
      "対象職員は他法人で継続異動加入の手続きが開始しているため、共済契約者間継続異動届の取下げはできません。",
    TKMSG_SVR0299E:
      "アップロードされたCSVに、退職（予定）日が前年度３月３１日以前の職員番号が含まれています。入力内容をご確認のうえもう一度CSVアップロードを行ってください。",
    TKMSG_SVR0300E:
      "氏名、生年月日が同じ職員がすでに登録されています。登録内容をご確認ください。",
    TKMSG_SVR0301E: "この入金データは取り込み済みです。",
    TKMSG_SVR0302E:
      "育休開始月が翌月以降のため、育休開始月の出勤日数を登録することができません。育休開始月到来後に出勤日数を登録してから、退職届を提出して下さい。",
    TKMSG_SVR0303E:
      "育休終了月が翌月以降のため、育休終了月の出勤日数を登録することができません。育休終了月到来後に出勤日数を登録してから、退職届を提出して下さい。",
    TKMSG_SVR0304E:
      "育休出勤日数が登録されていない月があります。「育休確認・登録ボタン」から日数を登録してください。",
    TKMSG_SVR0305E:
      "育休出勤日数が不正です。「育休確認・登録ボタン」から正しい日数を登録してください。",
    TKMSG_SVR0306E:
      "退職月の出勤日数と育休出勤日数が一致しません。「退職月の出勤日数」を修正してください。",
    TKMSG_SVR0307E:
      "退職月の出勤日数が出勤可能日数を超えています。「退職月の出勤日数」を正しく登録してください。",
    TKMSG_SCR0035W:
      "俸給表の額が73,999円以下となっています。入力内容が正しいかご確認ください。入力内容が正しい場合は「更新」ボタンを押下してください。",
    TKMSG_SCR0036W:
      "俸給表の額が5,000,000円以上となっています。入力内容が正しいかご確認ください。入力内容が正しい場合は「更新」ボタンを押下してください。",
    TKMSG_SCR0129E: "{$1}円以上の数値を入力してください。",
    TKMSG_SCR0130E: "{$1}円以下の数値を入力してください。",
    // TKMSG_SVR0308E: "{$1}年4月1日以前の加入者が「新規加入者の登録」に一時保存されています。{$2}加入届を機構へ提出後または一時保存中の加入届を削除後、掛金届を提出してください。",
    TKMSG_SVR0309E:
      "当該施設は「加入止め」または「部分解除」を行っている施設となるため、加入できません。",
    TKMSG_SVR0310E:
      "当該施設は「部分解除」を一時保存しているため、加入できません。「部分解除」の申請を取下げ後に登録してください。",
    TKMSG_SVR0311E:
      "当該施設は「社会福祉施設等から特定介護保険施設等への転換届」を一時保存しているため、加入できません。「社会福祉施設等から特定介護保険施設等への転換届」を取下げ後に登録してください。",
    TKMSG_SVR0312E:
      "当該職員は、「部分解除」を一時保存している施設に配置換えはできません。「部分解除」の申請を取下げ後に登録してください。",
    TKMSG_SVR0313E:
      "当該職員は、「社会福祉施設等から特定介護保険施設等への転換届」を一時保存している施設に配置換えはできません。「社会福祉施設等から特定介護保険施設等への転換届」を取下げ後に登録してください。",
    TKMSG_SVR0314E:
      "当該施設への加入者が「新規加入者の登録」に一時保存されているため、登録できません。加入届を機構へ提出後または一時保存中の加入届を削除後に登録してください。",
    TKMSG_SVR0315E:
      "転換日以降に加入した職員が存在するため、「転換する日以後の職員の加入有無」を「無」で登録することはできません。「有」に変更して機構へ提出し、「部分解除」の申請を行ってください。",
    TKMSG_SVR0316E:
      "「施設種類の変更」の手続きが進行中であるため、登録できません。",
    TKMSG_SVR0317E:
      "「社会福祉施設等から特定介護保険施設等への転換届」の手続きが進行中であるため、登録できません。",
    TKMSG_SVR0318E:
      "「掛金が３倍になる職員を加入させる手続き」が進行中であるため、登録できません。",
    TKMSG_SVR0319E: "「部分解除」の手続きが進行中であるため、登録できません。",
    TKMSG_SVR0320E:
      "対象職員は経営移管または継続異動により加入しているため、「掛金確定後の職員情報の訂正」はできません。",
    TKMSG_SVR0321E:
      "対象職員は新規契約時に加入しているため、「掛金確定後の職員情報の訂正」はできません。",
    TKMSG_SVR0322E:
      "対象職員は施設新設時に加入しているため、「掛金確定後の職員情報の訂正」はできません。",
    TKMSG_SVR0323E:
      "入力された加入日より前に加入以外の異動が存在するため、入力された加入日に変更することはできません。",
    TKMSG_SVR0324E:
      "入力された加入日より前に育休開始日が存在するため、入力された加入日に変更することはできません。",
    TKMSG_SVR0325E:
      "選択した施設の機構承認が完了していないため、新設届を修正する必要があります。機構に連絡し提出した新設届を差戻しの上、修正してください。",
    TKMSG_SVR0326E:
      "登録された特定職員数または措置入所障害児職員数が、施設の在籍職員数を超えています。登録内容をご確認ください。",
    TKMSG_SVR0327E:
      "「新設・申出年月日」が当年４月１日以前となっています。既に当年度の掛金届が提出済のため、先に掛金届の差戻しをしてください。その後、新設届の差戻しが可能となります。",
    TKMSG_SVR0328E:
      "「廃止・休止・経営移管年月日」が前年度３月３１日以前となっています。既に当年度の掛金届が提出済のため、先に掛金届の差戻しをしてください。その後、共済契約対象施設等一部廃止等届の差戻しが可能となります。",
    TKMSG_SVR0329E:
      "「解除年月日」が前年度３月３１日以前となっています。既に当年度の掛金届が提出済のため、先に掛金届の差戻しをしてください。その後、退職手当共済契約部分解除通知書の差戻しが可能となります。",
    TKMSG_SVR0330E:
      "「新設・申出年月日」が当年４月１日以前となっています。既に当年度は確定しているため、新設届の差戻しはできません。",
    TKMSG_SVR0331E:
      "「廃止・休止・経営移管年月日」が前年度３月３１日以前となっています。既に当年度は確定しているため、共済契約対象施設等一部廃止等届の差戻しはできません。",
    TKMSG_SVR0332E:
      "「解除年月日」が前年度３月３１日以前となっています。既に当年度は確定しているため、退職手当共済契約部分解除通知書の差戻しはできません。",
    TKMSG_SVR0333E:
      "「新設・申出年月日」が確定年度となっているため、新設届の差戻しはできません。",
    TKMSG_SVR0334E:
      "「廃止・休止・経営移管年月日」が確定年度となっているため、共済契約対象施設等一部廃止等届の差戻しはできません。",
    TKMSG_SVR0335E:
      "「解除年月日」が確定年度となっているため、退職手当共済契約部分解除通知書の差戻しはできません。",
    TKMSG_SVR0336E:
      "新設届の機構承認が完了していない施設で、特定職員数の値に不整合があるため、新設届を再提出する必要があります。機構に連絡し、提出した新設届を差戻しの上、再提出をしてください。その後、掛金届を提出してください。",
    TKMSG_SVR0337E:
      "登録された特定職員数または措置入所障害児職員数が、在籍職員数を超えている施設があります。「確認４.特定職員数または措置入所障害児職員数は正しいですか？」を「いいえ」にして特定職員数または措置入所障害児職員数を正しい値に更新してください。",
    TKMSG_SVR0035W:
      "当年度４月１日時点で、施設種類の変更などに伴い特定職員数または措置入所障害児職員数の登録条件を満たしていない施設があります。登録されている特定職員数または措置入所障害児職員数をクリアして手続きを進める場合は、「はい」を押下してください。",
  } as { [key: string]: string },
} as const;
